import { Outlet, useNavigation, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import { createContext, Dispatch, SetStateAction, useEffect, useState } from "react"; 
import MainLoader from "./utils/Loaders";
import NavbarMobile from "./components/NavbarMobile";
import { toast, Toaster } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { AuthVerify } from "./components/ApiRoutes";
import LoginDialog from "./components/LoginDialog";


interface UserContextType {
      user: {username?:string};
      setUser: Dispatch<SetStateAction<object>>;
    }

export const UserContext = createContext<UserContextType>({
    user:{},
    setUser: () => {}
  });


// main app structure
function App() {
  const location = useLocation();
  const { state } = useNavigation();

  const noNavRoutes = ["/", "/register"]; 

  const verifyRoutes = ["/login", "/consumelater/", "/profile/", "/list/edit"];

  const isAuthPage = noNavRoutes.includes(location.pathname);
  const [user, setUser] = useState<Object>({});

  interface VerifyVariables {
    access: string;
  }

  const verifyMutation = useMutation({
        mutationFn: (variables: VerifyVariables) => 
            AuthVerify(variables.access),
    });

  // verify user authentication on page load
  useEffect(() => {
    if (verifyRoutes.some(route => location.pathname.includes(route))) { // if any route is a substring
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        verifyMutation.mutate({ access: accessToken });
      } else {
        setUser({});
      }
    }
  },[location.pathname]);
  
  return (
    <>
    <Toaster />
    <UserContext.Provider value={{ user, setUser }}>
      {state === "loading" && (
        <section className="fixed inset-0 bg-primary z-50 flex items-center justify-center">
          <MainLoader />
        </section>
      )}
      
      <section className="bg-foreground relative grid grid-cols-12 lg:grid-cols-20 grid-rows-12 md:grid-rows-1 h-dvh overflow-hidden">
        
        {!isAuthPage && (
          <div className="hidden md:block md:col-span-1 md:row-span-1 xl:col-span-1"> 
            <Navbar /> 
          </div>
        )} 
        
        <div
          className={`
            ${isAuthPage ? "col-span-12 row-span-12 lg:col-span-20" : "col-span-12 md:col-span-11 lg:col-span-19"}
            row-span-11 md:row-span-1 bg-foreground overflow-y-auto `}
        >
          <Outlet />
        </div>
        
        {!isAuthPage && (
          <div
            className={`
              ${"col-span-12 md:hidden row-start-12 row-span-1 "} `}
          >
          <NavbarMobile />
          </div>
      )} 

      </section>
      </UserContext.Provider>
    </>
    
  );
}

export default App;